import MainRoutes from "./Routes"
import toast, { ToastBar, Toaster } from "react-hot-toast"
import LearnerAuthProvider from "./auth/learner/LearnerAuthProvider"

function App() {
  return (
    <div className="App">
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            borderRadius: 8,
            padding: "8px 14px",
            width: "400px !important",
            color: "var(--gray-800)",
            fontFamily: "Plus Jakarta Sans",
            fontSize: 16,
            fontWeight: 500,
            gap: 12,
          },
          success: {
            style: {
              background: "var(--success-25)",
              border: "1px solid var(--success-300)",
            },
          },
          error: {
            style: {
              background: "var(--brand-red-700)",
              border: "1px solid var(--brand-red-800)",
              color: "var(--white)",
            },
            iconTheme: {
              primary: "var(--white)",
              secondary: "var(--brand-red-800)",
            },
          },
          duration: 10000,
        }}
      >
        {(t) => (
          <ToastBar toast={t}>
            {({ icon, message }) => (
              <>
                {t.type === "error" ? (
                  <button
                    type="button"
                    aria-label="Dismiss"
                    onClick={() => toast.dismiss(t.id)}
                    style={{
                      display: "flex",
                      padding: 0,
                      border: 0,
                      background: "transparent",
                      cursor: "pointer",
                      color: "inherit",
                    }}
                  >
                    {icon}
                  </button>
                ) : (
                  icon
                )}
                {message}
              </>
            )}
          </ToastBar>
        )}
      </Toaster>
      <LearnerAuthProvider>
        <MainRoutes />
      </LearnerAuthProvider>
    </div>
  )
}

export default App
